<script setup lang="ts">
import BaseLayout from '@/components/base/BaseLayout.vue'
import type { FilterMap, FilterOption } from '@/types/filter.types'
import type { OpenClassFilter } from '@/types/open-class.types'
import { onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import OpenClassFilterSection from '../components/OpenClassFilterSection.vue'
import OpenClassListSection from '../components/OpenClassListSection.vue'

const router = useRouter()
const route = useRoute()

// 선택된 필터 상태 관리
const selectedCategory = ref<FilterOption>({
  idx: 0,
  name: '무료 클래스',
  data: 'free-class',
})

// 추가 필터 상태
const filters = reactive<OpenClassFilter>({
  level: { idx: 0, name: '전체 레벨', data: 'all' },
  sort: { idx: 0, name: '최신순', data: 'latest' },
})

// URL에서 카테고리와 필터 상태 가져오기
onMounted(() => {
  const categoryFromQuery = route.query.category as string
  if (categoryFromQuery === 'post') {
    selectedCategory.value = {
      idx: 1,
      name: '게시글',
      data: 'post',
    }
  }

  // 레벨 필터 복원
  const levelFromQuery = route.query.level as string
  if (levelFromQuery) {
    const levelOptionMap = {
      all: '전체 레벨',
      beginner: '초급',
      intermediate: '중급',
      advanced: '고급',
    }

    const levelOption = levelOptionMap[levelFromQuery as keyof typeof levelOptionMap]

    const levelKeys = Object.keys(levelOptionMap)
    const levelIdx = levelKeys.indexOf(levelFromQuery)

    if (levelOption) {
      filters.level = {
        idx: levelIdx,
        name: levelOption,
        data: levelFromQuery,
      }
    }
  }

  // 정렬 필터 복원
  const sortFromQuery = route.query.sort as string
  if (sortFromQuery) {
    const sortOptionMap = {
      latest: '최신순',
      oldest: '오래된순',
    }

    const sortOption = sortOptionMap[sortFromQuery as keyof typeof sortOptionMap]
    const sortKeys = Object.keys(sortOptionMap)
    const sortIdx = sortKeys.indexOf(sortFromQuery)

    if (sortOption) {
      filters.sort = {
        idx: sortIdx,
        name: sortOption,
        data: sortFromQuery,
      }
    }
  }
})

// 필터 변경 핸들러
const handleFilterChange = (category: FilterOption, filterOptions: FilterMap) => {
  selectedCategory.value = category
  if (filterOptions) {
    filters.level = filterOptions.level.selected
    filters.sort = filterOptions.sort.selected
  }

  // URL 쿼리 파라미터 업데이트
  router.replace({
    query: {
      ...route.query,
      category: category.data,
      level: filters.level.data,
      sort: filters.sort.data,
    },
  })
}
</script>

<template>
  <BaseLayout>
    <div class="open-class-view">
      <OpenClassFilterSection
        @change="handleFilterChange"
        :initialCategory="selectedCategory"
        :initialFilters="filters"
      />
      <OpenClassListSection :selectedCategory="selectedCategory" :filters="filters" />
    </div>
  </BaseLayout>
</template>

<style scoped>
.open-class-view {
  padding: 0px;
}

@media (max-width: 1365px) {
  .open-class-view {
    padding: 0px;
  }
}
</style>
